import React from 'react';
import { Container, Row } from 'react-bootstrap';

import { adminApi } from '../../api';
import { hasSuperuserAccess } from '../../utils';
import { SUPERUSER_LEVEL } from '../../constants';

import PageTitle from '../../components/common/PageTitle';
import EndUsersList from '../../components/common/endusers/EndUsersList';
import DisabledOverlay from '../../components/common/DisabledOverlay';

function EndUsers({ t, user }) {
  return (
    <Container className="main-content-container p-3 p-md-5 d-flex flex-column flex-grow-1">
      <Row className="g-0 page-header mb-3 mb-md-5">
        <PageTitle title={t('admin.endUsers.title')} backBtn />
      </Row>

      {hasSuperuserAccess(user, [SUPERUSER_LEVEL.FULL_ACCESS]) ? (
        <EndUsersList
          customer={false}
          filterName="admin_end_users"
          fetchData={adminApi.fetchEndUsers}
          fetchOptions={{ team: user.currentTeam.id }}
          generateRowUrl={(row) =>
            `/admin/end_user/${row.handle || row.original.user_handle}/profile`
          }
          hasPermissions={() => hasSuperuserAccess(user, [SUPERUSER_LEVEL.FULL_ACCESS])}
          usePrevNext
        />
      ) : (
        <div className="position-relative">
          <DisabledOverlay />
        </div>
      )}
    </Container>
  );
}

export default EndUsers;
